var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.305,
    height: 65.33,
    viewBox: "0 0 65.305 65.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_060-telegram",
    "data-name": "060-telegram",
    d: "M47.524,65.321a10.259,10.259,0,0,1-5.691-1.727l-13.7-9.115a2.552,2.552,0,1,1,2.828-4.25l13.7,9.115A5.18,5.18,0,0,0,52.637,55.9L60.223,11.15A5.178,5.178,0,0,0,53,5.558L8.239,25.574a5.176,5.176,0,0,0-.755,9.036l6.25,4.158a2.552,2.552,0,0,1-2.828,4.25l-6.25-4.158c-6.721-4.305-5.841-14.815,1.5-17.945L50.921.9A10.282,10.282,0,0,1,65.256,12L57.669,56.752a10.3,10.3,0,0,1-10.146,8.569ZM22.274,62.778V50.993a8.72,8.72,0,0,1,2.566-6.155L48.826,21.077a2.552,2.552,0,0,0-3.592-3.626L21.248,41.212a13.858,13.858,0,0,0-4.078,9.781V62.778a2.552,2.552,0,0,0,5.1,0Z",
    transform: "translate(-0.096 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPromotion);
export default __webpack_public_path__ + "static/media/ic_promotion.d0e7f2d4.svg";
export { ForwardRef as ReactComponent };